module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8vbAY"))).then(() => parcelRequire('37nVf'));